export default __webpack_public_path__ + "static/media/captivePortal.db8f07f9.svg";